module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.appStyle),
    attrs: {
      "id": "app"
    },
    on: {
      "mousemove": _vm.onMouseMove
    }
  }, [_c('loader'), _vm._v(" "), _c('navbar'), _vm._v(" "), _c('timeline', {
    attrs: {
      "display": _vm.childDisplay
    }
  }), _vm._v(" "), _c('about'), _vm._v(" "), _c('slider')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1556e17a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 86
// module chunks = 2